export default "__VITE_ASSET__CALVmdOq__"